import React, { useContext } from "react";
import { Typography } from "@rmwc/typography";
import { Button } from "@rmwc/button";
import { AppContext } from "../contexts/App";

import { Overlay } from "react-portal-overlay";
import { DisclaimerMessage, ApplicationName } from "../appConfig";
import useLocalStorage from "react-use/lib/useLocalStorage";
const SplashScreen = () => {
  const KEY = "mugis-template-disclaimer-seen";
  const [cache, setCache] = useLocalStorage(KEY);
  const [open, setOpen] = cache ? React.useState(false) : React.useState(true);

  return (
    <>
      <Overlay
        id="splashScreen"
        open={open}
        closeOnClick={false}
        onClose={() => {setOpen(false);setCache(true);}}
      >
        <div id="splashScreenHeader">
          <div className="toolbar__leading-icon" style={{marginRight: '10px'}}></div>
          <Typography use="headline6">{ApplicationName}</Typography>
        </div>
        <div id="splashScreenDisclaimer">
        <Typography use="headline6">DISCLAIMER</Typography>
        </div>
        <Typography
          use="body2"
          id="splashScreenContent"
          dangerouslySetInnerHTML={{ __html: DisclaimerMessage }}
        ></Typography>

        <div id="splashScreenFooter">
          <Button
            label="Accept"
            raised
            onClick={() => {
              setOpen(false);
              setCache(true);
            }}
          />
        </div>
      </Overlay>
    </>
  );
};

export default SplashScreen;
